import { render, staticRenderFns } from "./patrolStatistics.vue?vue&type=template&id=214f2f47&scoped=true&"
import script from "./patrolStatistics.vue?vue&type=script&lang=js&"
export * from "./patrolStatistics.vue?vue&type=script&lang=js&"
import style0 from "./patrolStatistics.vue?vue&type=style&index=0&id=214f2f47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214f2f47",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('214f2f47')) {
      api.createRecord('214f2f47', component.options)
    } else {
      api.reload('214f2f47', component.options)
    }
    module.hot.accept("./patrolStatistics.vue?vue&type=template&id=214f2f47&scoped=true&", function () {
      api.rerender('214f2f47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newDashboard/components/patrolStatistics.vue"
export default component.exports